module.exports = "/images/vendor/flag-icon-css/flags/1x1/ml.svg?204b0da4b499bc3694416d547a8fa0c0";